<script>
    import { createEventDispatcher } from "svelte";

    let dispatch = createEventDispatcher();
    export let audioGuide;

    export let customThumbnail;
    export let showDuration = false;
</script>

<div
    class="pCursor"
    style="display: flex; flex-direction:row;"
    on:click={() => dispatch("click")}
>
    <img
        style="display:block; "
        src={customThumbnail ? customThumbnail : audioGuide.image}
        alt={audioGuide.title}
        class="image imageBlur"
    />
    <div
        style="display: flex; flex-direction: column; justify-content: space-between; margin-left: 16px"
    >
        <div class="headline-xs title">{audioGuide.title}</div>
        <div style="display:flex; flex-direction:row;">
            <svg
                class="icon"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.5 4.86159L19.9922 12L7.5 19.1384L7.5 4.86159Z"
                    stroke="#1A1A17"
                />
            </svg>
            {#if showDuration && audioGuide.duration}
                <div style="margin-left: 8px">{audioGuide.duration}</div>
            {:else if audioGuide.trackId}
                <div>{audioGuide.trackId}</div>
            {/if}
        </div>
    </div>
</div>

<style>
    .image {
        width: 156px;
    }

    @media (min-width: 1440px) {
        .title {
            font-size: 40px;
            line-height: 100%;
            padding-right: 160px;
        }

        .image {
            width: 304px;
        }
    }
</style>
